import React, { useState } from "react";
import { SwipeableDrawer, IconButton, TextField, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import ButtonLoading from "../../../components/ButtonLoading";
import SubTitle from "../../../components/SubTitle";

import DialogConfirm from "../../../components/DialogConfirm";
import {
  createProject,
  deleteProject,
  updateProject,
} from "../../../api/projects";
import { USER_DATA } from "../../../utils/constants";
import randomRGBColor from "@chriscodesthings/random-rgb-color/src/randomRGBColor";
import Row from "../../../components/layout/Row";
import { CSSProperties } from "react";
import { ProjectsTypes } from "../../../interfaces/ProjectsTypes";
import Input from "../../../components/Input";
import { mountHistory } from "../../../utils/history";
import { createHistory } from "../../../api/history";
import { ActionTypeEnum } from "../../../interfaces/HistoryTypes";
import { select } from "../../dash/Dashboard.style";

const drawerWidth = 600;

interface NewProjectTypes {
  close: (reload?: boolean) => void;
  selectedProject?: ProjectsTypes;
}

function DrawerNewProject(props: NewProjectTypes) {
  const [open, setOpen] = useState(true);
  const [title, setTitle] = useState<string>(
    props.selectedProject ? props.selectedProject["title"] : ""
  );
  const [projectId, setProjectId] = useState<string>(
    props.selectedProject ? props.selectedProject["project_id"] : ""
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
    props.close();
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    setLoading(true);

    if (props.selectedProject && props.selectedProject["project_id"]) {
      let data: ProjectsTypes = {
        ...props.selectedProject,
      };

      data.title = title;

      updateProject(projectId, data)
        .then(() => {
          toast.success("Projeto atualizado com sucesso");
          if (props.selectedProject) {
            createHistory(
              mountHistory(
                projectId,
                ActionTypeEnum.UPDATE,
                "Projeto: de " +
                  props.selectedProject["title"] +
                  " para " +
                  title
              )
            );
          }
          props.close(true);
        })
        .catch((e) => {
          toast.error("Ocorreu um problema! " + e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      var color: any = randomRGBColor(true);
      color = `rgb(${color[0]},${color[1]},${color[2]})`;
      const newProjectId = String(new Date().getTime());

      const data: ProjectsTypes = {
        title: title,
        project_id: newProjectId,
        user_uuid: [JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid],
        main_user_uuid: JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid,
        color,
      };

      createProject(data)
        .then(() => {
          toast.success("Projeto adicionado com sucesso");
          createHistory(
            mountHistory(
              newProjectId,
              ActionTypeEnum.CREATE,
              "Projeto: " + title
            )
          );
          props.close(true);
        })
        .catch((e) => {
          toast.error("Ocorreu um problema! " + e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteItem = (responseOk: boolean) => {
    setOpenDelete(false);
    if (!responseOk) {
      return;
    }

    setLoading(true);

    deleteProject(projectId)
      .then(() => {
        toast.success("Projeto excluído com sucesso");
        createHistory(
          mountHistory(projectId, ActionTypeEnum.CREATE, "Projeto: " + title)
        );
        props.close(true);
      })
      .catch((e) => {
        toast.error("Ocorreu um problema! " + e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        zIndex: "1300",
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <Row padding>
        <div style={styles.buttonClose}>
          <IconButton component="span" onClick={toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <span style={styles.title}>
          {props.selectedProject?.project_id
            ? "Atualizar Projeto"
            : "Adicionar Projeto"}
        </span>
      </Row>
      <Divider />

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div style={styles.box}>
          <SubTitle text="Informações do projeto" />
          <Input
            title="Título"
            placeholder="Digite o título do seu projeto"
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <ButtonLoading
            label={
              props.selectedProject?.project_id
                ? "Atualizar projeto"
                : "Salvar projeto"
            }
            loading={loading}
          />

          {props.selectedProject?.project_id ? (
            <ButtonLoading
              label="Excluir"
              onClick={() => setOpenDelete(true)}
              isDelete
            />
          ) : null}
        </div>
      </form>
      {openDelete && (
        <DialogConfirm onResponse={deleteItem} entity="esse projeto" />
      )}
    </SwipeableDrawer>
  );
}

const styles: { [key: string]: CSSProperties } = {
  buttonClose: {
    background: "#C4C4C4",
    borderRadius: "6px",
    height: "32px",
    width: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    padding: "12px",
  },
  box: {
    padding: "20px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  itemBox: {
    width: "100%",
    marginBottom: "20px",
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "19px",
    lineHeight: "28px",
    letterSpacing: "0.4px",
    color: "#252733",
  },
};

export default DrawerNewProject;
